import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=3f5a9952&functional=true&"
var script = {}
import style0 from "./Wrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports